/* ============================================================================
   JuiceBox Adventskalender — behaviour for sections/jb-adv-hero + jb-adv-selector
   Modules: deadline countdown + phase flip, variant cards, gallery, sticky bar,
   add-to-cart. The initial state is server-rendered by Liquid; this file only
   keeps it live. Loaded (deferred) by both sections, so it guards against
   running twice.

   Cart contract (Impact 6.5, same as assets/jb-mix-and-match.js):
     POST /cart/add.js { items, sections, sections_url } with X-Requested-With,
     then GET /cart.js, attach `sections`, dispatch `variant:add` (opens the
     drawer) and `cart:change` with baseEvent 'variant:add' (renders it at 0 ms).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__jbAdvInit) return;
  window.__jbAdvInit = true;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* ==================== deadline countdown + phase ==================== */

  var phaseRoots = Array.prototype.slice.call(document.querySelectorAll('[data-adv-phase-root]'));
  var cdRoot = document.querySelector('[data-adv-countdown-root]');

  function closeEverywhere() {
    phaseRoots.forEach(function (r) {
      // sold-out stays sold-out; presale becomes closed.
      if (r.getAttribute('data-adv-phase') === 'presale') r.setAttribute('data-adv-phase', 'closed');
    });
  }

  // At the sale start: upcoming → the phase Liquid prepared for it (selling, or soldout when no variant is available).
  function openEverywhere() {
    phaseRoots.forEach(function (r) {
      if (r.getAttribute('data-adv-phase') === 'upcoming') r.setAttribute('data-adv-phase', r.getAttribute('data-adv-open-phase') || 'presale');
    });
  }

  if (cdRoot) {
    var endMs = parseInt(cdRoot.getAttribute('data-adv-end'), 10) * 1000;
    var toStart = cdRoot.getAttribute('data-adv-cd-mode') === 'upcoming';
    if (isFinite(endMs) && endMs > 0) {
      var digits = {
        d: document.querySelectorAll('[data-adv-cd="d"]'),
        h: document.querySelectorAll('[data-adv-cd="h"]'),
        m: document.querySelectorAll('[data-adv-cd="m"]'),
        s: document.querySelectorAll('[data-adv-cd="s"]')
      };
      var liveEl = document.querySelector('[data-adv-countdown]');
      var lastMinute = -1;
      var timer = null;

      var setDigit = function (key, value) {
        Array.prototype.forEach.call(digits[key], function (el) {
          if (el.textContent !== value) el.textContent = value;
        });
      };

      var tick = function () {
        var diff = Math.floor((endMs - Date.now()) / 1000);
        if (diff <= 0) {
          setDigit('d', '00');
          setDigit('h', '00');
          setDigit('m', '00');
          setDigit('s', '00');
          if (toStart) openEverywhere();
          else closeEverywhere();
          if (timer) {
            clearInterval(timer);
            timer = null;
          }
          return;
        }
        var d = Math.floor(diff / 86400);
        var h = Math.floor((diff % 86400) / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var s = diff % 60;
        setDigit('d', pad(d));
        setDigit('h', pad(h));
        setDigit('m', pad(m));
        setDigit('s', pad(s));
        if (liveEl && m !== lastMinute) {
          lastMinute = m;
          liveEl.setAttribute('aria-label', 'Noch ' + d + ' Tage, ' + h + ' Stunden und ' + m + ' Minuten ' + (toStart ? 'bis zum Verkaufsstart' : 'bis zum Ende des Vorverkaufs'));
        }
      };

      tick();
      timer = setInterval(tick, 1000);
      // Background tabs throttle timers; re-tick the moment the tab is visible again so a
      // visitor coming back after the deadline sees the closed state, not a stale countdown.
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) tick();
      });
    }
  }

  /* ==================== selector ==================== */

  var sel = document.querySelector('[data-adv-selector]');
  if (!sel) return;

  var cfgEl = sel.querySelector('[data-adv-config]');
  var CFG = null;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (err) {
    console.error('[jb-adv] config parse failed', err);
    return;
  }

  var cards = Array.prototype.slice.call(sel.querySelectorAll('[data-adv-choice]'));
  var addButtons = Array.prototype.slice.call(sel.querySelectorAll('[data-adv-add]'));
  var totals = Array.prototype.slice.call(sel.querySelectorAll('[data-adv-total]'));
  var stickyName = sel.querySelector('[data-adv-sticky-name]');
  var errorEl = sel.querySelector('[data-adv-error]');
  var sticky = sel.querySelector('[data-adv-sticky]');
  var live = sel.querySelector('[data-adv-live]');

  var choice = null;
  var inFlight = false;

  function announce(text) {
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 30);
  }

  function showError(text) {
    if (!errorEl) return;
    if (!text) {
      errorEl.hidden = true;
      errorEl.textContent = '';
      return;
    }
    errorEl.textContent = text;
    errorEl.hidden = false;
  }

  function select(key, focus) {
    var def = CFG.choices[key];
    if (!def || !def.available) return;
    choice = key;
    cards.forEach(function (card) {
      var on = card.getAttribute('data-adv-choice') === key;
      card.setAttribute('aria-checked', on ? 'true' : 'false');
      card.tabIndex = on ? 0 : -1;
      if (on && focus) card.focus();
    });
    totals.forEach(function (el) { el.textContent = def.price; });
    if (stickyName) stickyName.textContent = def.label;
    addButtons.forEach(function (btn) {
      btn.setAttribute('data-adv-choice-current', key);
    });
    showError('');
  }

  // Initial choice: the server-marked card if it is buyable, else the first buyable card.
  (function initChoice() {
    var marked = cards.filter(function (c) { return c.getAttribute('aria-checked') === 'true' && !c.disabled; })[0];
    var first = cards.filter(function (c) { return !c.disabled; })[0];
    var start = marked || first;
    if (start) select(start.getAttribute('data-adv-choice'), false);
  })();

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      if (card.disabled) return;
      select(card.getAttribute('data-adv-choice'), false);
    });
    card.addEventListener('keydown', function (event) {
      var enabled = cards.filter(function (c) { return !c.disabled; });
      var idx = enabled.indexOf(card);
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        var next = enabled[(idx + 1) % enabled.length];
        if (next) select(next.getAttribute('data-adv-choice'), true);
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        var prev = enabled[(idx - 1 + enabled.length) % enabled.length];
        if (prev) select(prev.getAttribute('data-adv-choice'), true);
      } else if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        select(card.getAttribute('data-adv-choice'), false);
      }
    });
  });

  function collectSections() {
    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function setBusy(busy) {
    addButtons.forEach(function (btn) {
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      btn.setAttribute('aria-disabled', busy ? 'true' : 'false');
      var label = btn.querySelector('[data-adv-add-label]');
      if (label) label.textContent = busy ? CFG.labels.busy : CFG.labels.add;
    });
  }

  async function addToCart(trigger) {
    if (inFlight) return;
    if (sel.getAttribute('data-adv-phase') !== 'presale') return;
    var def = choice && CFG.choices[choice];
    if (!def || !def.available) {
      showError(CFG.labels.pick);
      return;
    }

    var items = def.ids.map(function (id) {
      return { id: id, quantity: 1 };
    });
    if (CFG.bonusId) {
      // one digital calendar per physical calendar in this click ("Beide" = 2); the reconciler in
      // jb-adv-bonus-sync.js keeps the total in step with later quantity changes and removals
      items.push({ id: CFG.bonusId, quantity: def.ids.length, properties: { _adv_bonus: '1' } });
    }

    inFlight = true;
    setBusy(true);
    showError('');

    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);

    try {
      var sections = collectSections();
      var res = await fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal,
        body: JSON.stringify({
          items: items,
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });
      var json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'cart/add failed');

      var cart = await (await fetch(routeRoot + 'cart.js')).json();
      cart.sections = json.sections;

      // Exact detail shapes theme.js expects — the first opens the drawer, the second renders it.
      trigger.dispatchEvent(
        new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [], cart: cart } })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
      );
      announce(def.label + ' wurde in den Warenkorb gelegt.');
    } catch (err) {
      console.error('[jb-adv] add to cart failed', err);
      showError(err && err.name === 'AbortError' ? CFG.labels.error : (err && err.message) || CFG.labels.error);
    } finally {
      clearTimeout(timeout);
      inFlight = false;
      setBusy(false);
    }
  }

  addButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      addToCart(btn);
    });
  });

  /* ==================== gallery ==================== */

  var track = sel.querySelector('[data-adv-track]');
  var thumbs = Array.prototype.slice.call(sel.querySelectorAll('[data-adv-thumb]'));
  if (track && thumbs.length) {
    var slides = Array.prototype.slice.call(track.children);

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var slide = slides[i];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var i = slides.indexOf(entry.target);
          thumbs.forEach(function (t, j) {
            t.classList.toggle('is-active', i === j);
            t.setAttribute('aria-current', i === j ? 'true' : 'false');
          });
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  /* ==================== sticky bar (shows while the main CTA is off-screen) ==================== */

  var mainCta = sel.querySelector('[data-adv-add-main]');
  if (sticky && mainCta && 'IntersectionObserver' in window) {
    var seen = false;
    var ctaIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) seen = true;
        var phaseOk = sel.getAttribute('data-adv-phase') === 'presale';
        var below = entry.boundingClientRect.top < 0; // CTA scrolled past, not merely not-yet-reached
        sticky.hidden = !(phaseOk && seen && !entry.isIntersecting && below);
      });
    }, { threshold: 0.2 });
    ctaIo.observe(mainCta);
  }

  /* ==================== stock bars: animate the fill once visible ==================== */

  var fills = Array.prototype.slice.call(sel.querySelectorAll('.jb-adv-stock__fill'));
  if (fills.length && !reduceMotion && 'IntersectionObserver' in window) {
    fills.forEach(function (f) {
      f.setAttribute('data-adv-target', f.style.getPropertyValue('--adv-fill') || '0%');
      f.style.setProperty('--adv-fill', '0%');
    });
    var fillIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var f = entry.target;
        requestAnimationFrame(function () {
          f.style.setProperty('--adv-fill', f.getAttribute('data-adv-target'));
          f.removeAttribute('data-adv-target');
        });
        fillIo.unobserve(f);
      });
    }, { threshold: 0.4 });
    fills.forEach(function (f) { fillIo.observe(f); });
  }

  /* ==================== modelled stock curve (selector setting stock_mode = curve) ====================
     Same maths as snippets/jb-adv-stock-curve.liquid — keep both in step. Liquid paints the first value,
     this keeps an open tab moving (every 30 s, and when the tab becomes visible again). */

  if (CFG.curve) {
    var CV = CFG.curve;

    var curvePct = function (nowMs, speed) {
      var e = ((nowMs / 1000) - CV.launch) / 60 * speed;
      var total = (CV.end - CV.launch) / 60;
      var p1m = CV.p1[0], p1p = CV.p1[1], p2m = CV.p2[0], p2p = CV.p2[1], pend = CV.endPct;
      var pct;
      if (e <= 0) {
        pct = 100;
      } else if (e <= p1m) {
        var r = 1 - e / p1m;
        pct = p1p + (100 - p1p) * r * r;
      } else if (e <= p2m) {
        var u = (e - p1m) / Math.max(0.001, p2m - p1m);
        pct = p2p + (p1p - p2p) * (1 - u);
      } else {
        var u2 = Math.min(1, (e - p2m) / Math.max(1, total - p2m));
        pct = pend + (p2p - pend) * (1 - u2);
      }
      return Math.max(1, Math.min(100, Math.floor(pct)));
    };

    var applyStock = function (key, pct) {
      Array.prototype.forEach.call(sel.querySelectorAll('[data-adv-stock="' + key + '"]'), function (el) {
        var fill = el.querySelector('.jb-adv-stock__fill');
        var text = el.querySelector('.jb-adv-stock__text');
        if (fill) {
          if (fill.hasAttribute('data-adv-target')) fill.setAttribute('data-adv-target', pct + '%');
          else fill.style.setProperty('--adv-fill', pct + '%');
        }
        if (text) text.textContent = CV.text.replace('[p]', pct);
        el.classList.toggle('is-low', pct <= CV.lowPct);
      });
    };

    var tickStock = function () {
      if (sel.getAttribute('data-adv-phase') !== 'presale') return; // bars are hidden once the sale is over
      var now = Date.now();
      var l = curvePct(now, CV.speeds.light);
      // Original is held at least `gap` points BELOW Light (never under 1). Lowering, not raising:
      // a value a visitor has already seen must never go up.
      var o = curvePct(now, CV.speeds.original);
      if (o < 100) o = Math.max(1, Math.min(o, l - (CV.gap || 0))); // 100/100 until the curve starts
      applyStock('light', l);
      applyStock('original', o);
      applyStock('both', Math.min(l, o));
    };

    tickStock();
    setInterval(tickStock, 30000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tickStock();
    });
  }
})();
